import React, { useState } from "react";
import { Button, Typography, Box } from "@mui/material";
import { Container, Row } from "react-bootstrap";
import axiosInstance from "../../Utils/axiosInstance";
import { backendbaseUrl } from "../../Utils/baseUrl";
import FileUpload from "./FileUploadModal";

const FileUploads: React.FC = () => {
  const [openUploadDialog, setOpenUploadDialog] = useState<boolean>(false);

  const handleOpenUploadDialog = () => {
    setOpenUploadDialog(true);
  };

  const handleCloseUploadDialog = () => {
    setOpenUploadDialog(false);
  };

  const handleFileUploadSubmit = async (file: File) => {
    try {
      // Validate file type
      const validTypes = [".csv", ".xlsx"];
      const fileExtension = file.name.slice(file.name.lastIndexOf(".")).toLowerCase();
      if (!validTypes.includes(fileExtension)) {
        return {
          success: false,
          message: `Invalid file type for ${file.name}. Only CSV and XLSX files are allowed.`,
        };
      }

      // Create a FormData object to send the file
      const formData = new FormData();
      formData.append("file", file);

      const response = await axiosInstance.post(
        `${backendbaseUrl}/paper-app/upload-file/`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.status >= 200 && response.status < 300) {
        return {
          success: true,
          message: `File ${file.name} uploaded successfully!`,
          data: response.data,
        };
      }

      return {
        success: false,
        message: `Failed to upload file ${file.name}.`,
      };
    } catch (error: any) {
      console.error("Error uploading file:", error);
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Failed to upload file due to a network or server error.";
      return {
        success: false,
        message: errorMessage,
      };
    }
  };

  return (
    <Box className="page-body">
      <Container fluid>
        <Row>
          <Box className="table-ad">
            <Box className="table-ad__addInputs">
              <Typography variant="h4" component="h1">
               file uploads
              </Typography>
              <Button
                variant="contained"
                color="primary"
                onClick={handleOpenUploadDialog}
                sx={{ mb: 2 }}
                aria-label="Upload Settlement Prices"
              >
                file uploads
              </Button>
              <FileUpload
                open={openUploadDialog}
                onFileUploadClose={handleCloseUploadDialog}
                onFileUploadSubmit={handleFileUploadSubmit}
                acceptedFileTypes=".csv"
              />
            </Box>
          </Box>
        </Row>
      </Container>
    </Box>
  );
};

export default FileUploads;